
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCardSimilarSpecializationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCard_ProductCard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingProductType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productTypeAttributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCard_Specialization"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPathwayContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPartOfCourseraPlus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalAssignmentCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasTopInstructor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonical"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestSpecialization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageFiveStarRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"difficultyLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skillId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isToolSoftware"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"launchedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardImageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urlPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squareLogo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"coBrandingEnabled"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":803}};
    doc.loc.source = {"body":"fragment ProductCardSimilarSpecializationFragment on ProductCard_ProductCard {\n  id\n  marketingProductType\n  badges\n  productTypeAttributes {\n    __typename\n    ... on ProductCard_Specialization {\n      isPathwayContent\n      isPartOfCourseraPlus\n      totalAssignmentCount\n      hasTopInstructor\n      canonical {\n        latestSpecialization {\n          rating {\n            averageFiveStarRating\n            ratingCount\n          }\n          difficultyLevel\n          skillTags {\n            skillId\n            skillName\n            isToolSoftware\n          }\n          launchedAt\n\n          cardImageUrl\n          urlPath\n          slug\n          name\n          partners {\n            id\n            name\n            squareLogo\n          }\n          coBrandingEnabled\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductCardSimilarSpecializationFragment"] = oneQuery(doc, "ProductCardSimilarSpecializationFragment");
        
